import { PrintTagsModal } from "./PrintTagsModal";

export default PrintTagsModal;
